import React from 'react';
import styled from 'styled-components';
const StyledBox = styled.div `
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    width: ${props => (props.fullWidth ? '100%' : 'auto')};
`;
const Box = ({ className, children, padding, margin, fullWidth, }) => (React.createElement(StyledBox, { className: className, margin: margin, padding: padding, fullWidth: fullWidth }, children));
export default Box;
